module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emailsuccess":"Got it! you will receive the email shortly.","emailfailure":"Oops! There is some problem with email service. Try again later","sendButton":"Send"},"es":{"emailsuccess":"¡Entendido! recibirá el correo electrónico en breve","emailfailure":"¡Ups! Hay algún problema con el servicio de correo electrónico. Vuelva a intentarlo más tarde","sendButton":"Enviar"}}')
  delete Component.options._Ctor
}
